import BatchesTable from "./BatchesTable"

export default BatchesTable
